import styled from 'styled-components';
import { Text } from '@makemydeal/dr-ui-bricks-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

export const SectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: 24px;
    padding: 16px;
    background: ${({ theme }) => theme.uiBricks.modalBackgroundColor || '#ffffff'};
    flex: 1 1 0;
`;

export const SectionTitle = styled.div`
    padding-bottom: 11px;
`;

export const FuelGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const FuelCard = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f4f4f4;
    border-radius: 4px;
    padding: 16px 20px;

    @media (max-width: ${BreakPoints.PHONE}) {
        padding: 12px 16px;
    }
`;

export const FuelValueWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

export const FuelUnitLabel = styled(Text)`
    color: #636569;
`;
